<template>
    <div class="circle-charts-page">
        <div class="charts" ref="circleCharts"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: "CircleCharts",
    props:{
        // 饼图的颜色
        colors: {
            type: Array,
            default(){
                return ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#45C2E0', '#C1EBDD', '#FFC851','#5A5476','#1869A0','#FF9393'];
            }
        },
        // 数据列表
        list: {
            type: Array,
            default(){
                return []
            }
        }
    },
    mounted(){
        this.myChart = echarts.init(this.$refs.circleCharts);
        window.addEventListener("resize", this.handleWindowResize);
    },
    beforeDestroy(){
        // window.removeEventListener("resize", this.handleWindowResize);
    },
    data(){
        return {
            myChart: null,
            // 数据
            chartsList: [],
            // 总数
            total: 0,
        }
    },
    methods: {
        initData(){
            if(this.myChart){
                this.initCharts()
            }
        },

        // 初始饼状图
        initCharts(){
            const option = {
                color: this.colors,
                title: {
                    text: this.total,
                    left: '29%',
                    top: 'middle',
                    subtext: '总数',
                    textAlign: 'center',
                    itemGap: 5,
                    textStyle: {
                        fontSize: 22,
                        color: '#fff',
                        
                    },
                    subtextStyle: {
                        fontSize: 18,
                        color: '#b4b4b4',
                        fontFamily: 'Regular'
                    }
                },
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    width: '0%',
                    // orient: "vertical",
                    right: '0%',
                    top: '0%',
                    selectedMode: false,
                    icon: 'circle',
                    itemGap: 23,
                    textStyle: {
                        fontSize: 14,
                        color: '#b4b4b4',
                    },
                    itemStyle: {
                        borderWidth: 0,
                    },
                    formatter: (name) => {
                        if(this.total > 0){
                            for(let i=0; i<this.chartsList.length; i++){
                                if(name === this.chartsList[i].name){
                                    return `${name}寸 ${((this.chartsList[i].value/this.total)*100).toFixed(2)}%`
                                }
                            }
                        }else{
                            return name
                        }
                    }
                },
                series: [
                    {
                        name: '屏幕分布',
                        type: 'pie',
                        radius: ['60%', '85%'],
                        center: ['30%', '50%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: '#082944',
                            borderWidth: 3
                        },
                        label: {
                            show: false
                        },
                        zlevel: 16,
                        data: this.chartsList
                    }
                ]
            };
            this.myChart.setOption(option);
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                this.chartsList = value,
                this.total = 0;
                value.map(item => {
                    return this.total += item.value;
                });
                this.$nextTick(function (){
                    this.initData();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.circle-charts-page{
    width:100%;
    height:100%;
    display: flex;
    .charts{
        flex: 1;
    }
}
</style>